module.exports = __webpack_public_path__ + "03_short_brown.cbb8a11f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/03_short_brown.png
// module id = 6FOU
// module chunks = 0